import { ResolverProps } from '../utils/resolverHelpers';
import { accordionMapper } from './mapper';
import FullHorizontalAccordion from './fullHorizontal';
import FullVerticalAccordion from './fullVertical';
import OptionalViewport from '../../OptionalViewport';
import SectionTitleContainer from '../titles';
import { renderSeo } from './seo';
import StandardAccordion from './standard';
import prepIds from '../../seo/jsonLD/prepIds';

const accordionResolver = (props: ResolverProps<'accordion'>) => {
  const data = accordionMapper(
    props.section,
    props.context.config.sectionDefaults?.accordion,
  );
  const renderVariant = () => {
    if (data.variant === 'standard') {
      return <StandardAccordion {...props} data={data} />;
    }
    if (data.variant === 'fullVertical') {
      return (
        <>
          <OptionalViewport viewport={'d'} initIsMobile={props.isMobile}>
            <FullVerticalAccordion {...props} data={data} />
          </OptionalViewport>
          <OptionalViewport viewport={'m'} initIsMobile={props.isMobile}>
            <FullHorizontalAccordion {...props} data={data} />
          </OptionalViewport>
        </>
      );
    }
    if (data.variant === 'fullHorizontal') {
      return <FullHorizontalAccordion {...props} data={data} />;
    }
    return null;
  };

  return (
    <>
      {renderSeo(data, prepIds(data.seo, props.context.config.seo))}
      <SectionTitleContainer
        {...props}
        data={data.titles}
        variant={data.variant}
      >
        {renderVariant()}
      </SectionTitleContainer>
    </>
  );
};

export default accordionResolver;
